<script>
import axios from '@/utils/axios';

export default {
  name: 'Installations',
  inject: {
    setLoading: {
      default: () => () => {}
    }
  },
  data() {
    return {
      title: 'Installation',
      text: 'Installation',
      text1: 'Installations',
      loading: true,
      tableColumns: [
        { key: 'checkbox',              label: '',                  width: '40px' },
        { key: 'installation_number', label: 'Installation No' },
        // { key: 'sales_order',           label: 'Sales Order'                      },
        // { key: 'delivery_challan',      label: 'Delivery Challan'                 },
        // { key: 'installation_person',   label: 'Installation Person'              },
        { key: 'status',                label: 'Status'                           },
        { key: 'created_at',            label: 'Created At'                       },
        { key: 'actions',               label: 'Actions',           width: '80px' },
      ],
      installations: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: [],
      },
      search: '',
      searchTimer: null,
      selectedIds: [],
      editItem: null,
      selectedInstallation: null,
      whatsappLogs: [],
      whatsappLogsLoading: false,
      whatsappLogModalTitle: '',
    };
  },

  computed: {
    allSelected() {
      return this.installations.length > 0 && this.selectedIds.length === this.installations.length;
    },
  },

  mounted() {
    this.fetchInstallations();
  },

  methods: {

async assignInstaller(row) {
  const { value: formValues } = await this.$swal.fire({
    title: 'Assign to Installer',
    html: `
      <div class="mb-3 text-start">
        <label class="form-label fw-semibold">Installer Name <span class="text-danger">*</span></label>
        <input type="text" id="installerName" class="form-control" placeholder="Enter installer name" />
      </div>
      <div class="mb-3 text-start">
        <label class="form-label fw-semibold">Installer Mobile <span class="text-danger">*</span></label>
        <input type="text" id="installerMobile" class="form-control" placeholder="Enter installer mobile number" />
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Assign',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#198754',
    didOpen: () => {
      setTimeout(() => {
        document.getElementById('installerName').focus();
      }, 100);
    },
    preConfirm: () => {
      const installerName = document.getElementById('installerName').value.trim();
      const installerMobile = document.getElementById('installerMobile').value.trim();

      if (!installerName) {
        this.$swal.showValidationMessage('Please enter installer name');
        return false;
      }
      if (!installerMobile) {
        this.$swal.showValidationMessage('Please enter installer mobile number');
        return false;
      }
      if (!/^\d{10}$/.test(installerMobile)) {
        this.$swal.showValidationMessage('Please enter a valid 10-digit mobile number');
        return false;
      }
      return {
        installer_name: installerName,
        installer_mobile: installerMobile,
        id: row.id
      };
    }
  });

  if (formValues) {
    await this.saveAssignInstaller(formValues);
  }
},

async saveAssignInstaller(formValues) {
  this.setLoading(true);
  try {
    await axios.patch(`/installations/${formValues.id}/assign-installer`, {
      installer_name: formValues.installer_name,
      installer_mobile: formValues.installer_mobile
    });
    this.$swalToast('Installer assigned successfully!', 'success');
    await this.fetchInstallations(this.pagination.current_page);
  } catch (error) {
    this.$swalToast(error.response?.data?.message || 'Failed to assign installer', 'error');
  } finally {
    this.setLoading(false);
  }
},

async openActivity(row) {
  this.setLoading(true);
  try {
    const res = await axios.get(`/installations/${row.id}`);
    this.selectedInstallation = res.data.data;
    this.$openModal('installationActivityModal');
  } catch(e) {
    this.$swalToast(e?.message || 'Failed to load activity', 'error');
  } finally {
    this.setLoading(false);
  }
},

async openWhatsappLogs(row) {
  this.whatsappLogModalTitle = row.installation_number || '';
  this.whatsappLogs = [];
  this.whatsappLogsLoading = true;
  this.$openModal('whatsapp_logs_modal');
  try {
    const response = await axios.get(`/whatsapp-logs/Installation/${row.id}`);
    this.whatsappLogs = response.data.data || [];
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.whatsappLogsLoading = false;
  }
},

whatsappStatusBadge(status) {
  const map = {
    sent: 'bg-success-subtle text-success',
    failed: 'bg-danger-subtle text-danger',
    pending: 'bg-warning-subtle text-warning',
  };
  return map[status] || 'bg-secondary-subtle text-secondary';
},

formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
},

async updateStatusSwal(row) {
  const { value: formData } = await this.$swal.fire({
    title: 'Update Status',
    html: `
  <select id="statusSelect" class="form-select mb-2">
    <option value="">Select Status</option>
    ${row.status !== 'work_in_progress' ? '<option value="work_in_progress">Work In Progress</option>' : ''}
    ${row.status !== 'postponed' ? '<option value="postponed">Postponed</option>' : ''}
    ${row.status !== 'completed' ? '<option value="completed">Completed</option>' : ''}
  </select>
  <div id="postponedDateWrapper" style="display:none;" class="mb-2">
    <input type="date" id="postponedDate" class="form-control" min="${new Date().toISOString().split('T')[0]}" />
  </div>
  <div id="documentWrapper" style="display:none;" class="mb-2 text-start">
    <label class="form-label fw-semibold" style="font-size:12px;">Document <span class="text-danger">*</span></label>
    <input type="file" id="completionDocument" class="form-control" accept=".pdf,.jpg,.jpeg,.png" />
  </div>
      <textarea id="remarkInput" class="form-control mt-2" rows="2" placeholder="Remark"></textarea>
    `,
    didOpen: () => {
      document.getElementById('statusSelect').addEventListener('change', function () {
        const postponedWrapper = document.getElementById('postponedDateWrapper');
        const documentWrapper = document.getElementById('documentWrapper');
        postponedWrapper.style.display = this.value === 'postponed' ? 'block' : 'none';
        documentWrapper.style.display = this.value === 'completed' ? 'block' : 'none';
      });
    },
    showCancelButton: true,
    confirmButtonText: 'Update',
    confirmButtonColor: '#198754',
    preConfirm: () => {
            const status = document.getElementById('statusSelect').value;
            const postponedAt = document.getElementById('postponedDate').value;
            const remark = document.getElementById('remarkInput').value.trim();
            const documentFile = document.getElementById('completionDocument').files[0] || null;

            if (!status) {
                this.$swal.showValidationMessage('Please select a status');
                return false;
            }
            if (status === 'postponed' && !postponedAt) {
                this.$swal.showValidationMessage('Please select a postponed date');
                return false;
            }
            if (status === 'completed' && !documentFile) {
                this.$swal.showValidationMessage('Please upload a document to mark as completed');
                return false;
            }
            return { status, postponedAt: status === 'postponed' ? postponedAt : null, remark, documentFile };
            }
  });

  if (formData) {
    await this.updateStatus(row.id, formData.status, formData.postponedAt, formData.remark, formData.documentFile);
  }
},

async openDetail(row) {
  this.setLoading(true);
  try {
    const res = await axios.get(`/installations/${row.id}`);
    this.selectedInstallation = res.data.data;
    this.$openModal('installationDetailModal');
  } catch(e) {
    this.$swalToast(e?.message || 'Failed to load details', 'error');
  } finally {
    this.setLoading(false);
  }
},


    async fetchInstallations(page = 1) {
      this.loading = true;
      try {
        const params = {
          page,
          per_page: this.pagination.per_page,
          search: this.search.trim() || undefined,
        };
        const res = await axios.get('/installations', { params });
        const d = res.data.data;
        this.installations = d.data;
        this.pagination = {
          current_page: d.current_page,
          per_page:      d.per_page || 25,
          last_page:     d.last_page,
          total:         d.total,
          links:         d.links || [],
        };
      } catch (e) {
        this.$swalToast(e?.response?.data?.message || 'Failed to load installations.', 'error');
      } finally {
        this.loading = false;
      }
    },

    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.fetchInstallations(1), 400);
    },

    handleToggleAll(event) {
      this.selectedIds = event.target.checked ? this.installations.map(r => r.id) : [];
    },

    openCreate() {
      this.editItem = null;
      this.$openModal('installationModal');
    },

    openEdit(item) {
      this.editItem = { ...item };
      this.$openModal('installationModal');
    },

    onSaved() {
      this.fetchInstallations(this.pagination.current_page);
    },

    async deleteInstallation(id) {
      const result = await this.$confirm({
        title: 'Delete Installation?',
        text: 'This action cannot be undone.',
        confirmButtonText: 'Yes, delete it!',
      });
      if (!result.isConfirmed) return;
      this.setLoading(true);
      try {
        await axios.delete(`/installations/${id}`);
        this.$swalToast('Installation deleted successfully.');
        this.fetchInstallations(this.pagination.current_page);
      } catch (e) {
        this.$swalToast(e?.response?.data?.message || 'Something went wrong.', 'error');
      } finally {
        this.setLoading(false);
      }
    },

async updateStatus(id, status, postponedAt = null, remark = null, documentFile = null) {
  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('status', status);
    formData.append('remark', remark || '');
    if (postponedAt) formData.append('postponed_at', postponedAt);
    if (documentFile) formData.append('document', documentFile);

    await axios.post(`/installations/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    this.$swalToast('Status updated successfully.');
    this.fetchInstallations(this.pagination.current_page);
  } catch (e) {
    this.$swalToast(e?.response?.data?.message || 'Something went wrong.', 'error');
  } finally {
    this.setLoading(false);
  }
},

    statusBadge(status) {
      const map = {
        pending:     { cls: 'badge-soft-warning',  label: 'Pending'     },
        work_in_progress: { cls: 'badge-soft-info',      label: 'Work In Progress' },
        processing: { cls: 'badge-soft-info', label: 'Processing' },
        postponed:  { cls: 'badge-soft-secondary', label: 'Postponed'  },
        completed:   { cls: 'badge-soft-success',  label: 'Completed'   },
        cancelled:   { cls: 'badge-soft-danger',   label: 'Cancelled'   },
      };
      return map[status] || { cls: 'badge-soft-secondary', label: status || 'N/A' };
    },

    clearFilter() {
      this.search = '';
      this.fetchInstallations(1);
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
          <button v-if="auth?.role?.name === 'Dispatch'" class="btn btn-primary d-flex align-items-center" @click="openCreate">
            <i class="ti ti-circle-plus me-2"></i>Add Installation
          </button>
        </div>
      </div>

      <!-- Main Card -->
      <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">

        <!-- Card Header -->
        <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
          <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
            Installations
            <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">
              ({{ $numFormat(pagination.total) }})
            </span>
            <button
              v-if="search"
              class="btn btn-sm ms-2"
              style="display:inline-flex;align-items:center;width:28px;height:28px;font-size:13px;background:#fff0f3;border:1.5px solid #fecdd3;border-radius:8px;color:#f43f5e;padding:0;justify-content:center;"
              @click="clearFilter"
              title="Clear Filters"
            >
              <i class="ti ti-filter-x"></i>
            </button>
          </h5>

          <!-- Filters -->
          <div class="d-flex align-items-center flex-wrap gap-2">
            <!-- Per Page -->
            <vue-select
              v-model="pagination.per_page"
              :options="[
                { label: '25', value: 25 },
                { label: '50', value: 50 },
                { label: '75', value: 75 },
                { label: '100', value: 100 },
              ]"
              label="label"
              :reduce="p => p.value"
              placeholder="Per Page"
              :clearable="false"
              @update:modelValue="fetchInstallations(1)"
              style="min-width: 100px;"
            ></vue-select>

            <!-- Search -->
            <div style="display:flex;align-items:center;border:1.5px solid #e2e8f0;border-radius:8px;overflow:hidden;background:#fff;">
              <input
                type="text"
                v-model="search"
                @input="onSearch"
                placeholder="Search installations..."
                style="border:none;outline:none;height:34px;padding:0 10px;font-size:12.5px;color:#1e293b;width:200px;background:transparent;"
              />
              <span style="padding:0 10px;color:#94a3b8;"><i class="ti ti-search"></i></span>
            </div>
          </div>
        </div>

        <!-- Card Body -->
        <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">

          <app-table
            :columns="tableColumns"
            :rows="installations"
            :pagination="pagination"
            :loading="loading"
            :skeleton-rows="25"
            empty-text="No installations found."
            empty-icon="ti ti-tools"
            @page-change="fetchInstallations"
          >

            <!-- Checkbox Header -->
            <template #header-checkbox>
              <div class="form-check form-checkbox-success mb-0">
                <input type="checkbox" class="form-check-input" :checked="allSelected" @change="handleToggleAll" />
              </div>
            </template>

            <!-- Checkbox -->
            <template #checkbox="{ row }">
              <div class="form-check form-checkbox-success mb-0">
                <input type="checkbox" class="form-check-input" :value="row.id" v-model="selectedIds" />
              </div>
            </template>

            <template #installation_number="{ row }">
            <a href="javascript:void(0);" 
                class="text-primary fw-medium"
                @click="openDetail(row)">
                {{ row.installation_number }}
            </a>
            </template>

            <!-- Serial -->
            <template #serial="{ index }">
              <span style="font-size:13px;color:#64748b;">
                {{ (pagination.current_page - 1) * pagination.per_page + index + 1 }}
              </span>
            </template>

            <!-- Sales Order -->
            <template #sales_order="{ row }">
              <div v-if="row.sales_order">
                <span style="font-size:13px;font-weight:600;color:#0f172a;">
                  {{ row.sales_order.name || '—' }}
                </span>
                <br />
                <small style="font-size:11px;color:#94a3b8;">{{ row.sales_order.so_number }}</small>
              </div>
              <span v-else style="font-size:12px;color:#94a3b8;">—</span>
            </template>

            <!-- Delivery Challan -->
            <template #delivery_challan="{ row }">
              <span v-if="row.delivery_challan" style="font-size:13px;color:#0f172a;">
                {{ row.delivery_challan.challan_number || row.delivery_challan_id }}
              </span>
              <span v-else style="font-size:12px;color:#94a3b8;">—</span>
            </template>

            <!-- Installation Person -->
            <template #installation_person="{ row }">
              <div v-if="row.installation_person" style="display:flex;align-items:center;gap:6px;">
                <span
                  style="display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;font-size:11px;font-weight:700;color:#fff;"
                  :style="{ background: `hsl(${((row.installation_person.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }"
                >
                  {{ (row.installation_person.name || '').charAt(0).toUpperCase() }}
                </span>
                <span style="font-size:13px;color:#1e293b;">{{ row.installation_person.name }}</span>
              </div>
              <span v-else style="font-size:12px;color:#94a3b8;">—</span>
            </template>

            <!-- Status -->
            <template #status="{ row }">
              <span :class="'badge ' + statusBadge(row.status).cls">
                {{ statusBadge(row.status).label }}
              </span>
            </template>

            <!-- Created At -->
            <template #created_at="{ row }">
              <span style="font-size:11.5px;color:#94a3b8;">
                {{ row.created_at ? $formatDate(row.created_at) : '—' }}
              </span>
            </template>

            <!-- Actions -->
            <template #actions="{ row }">
            <div class="dropdown">
                <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown">
                <i class="ti ti-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end p-3">

                <!-- Completed status no actions -->
                <li v-if="auth?.role?.name === 'Installation' && row.status === 'completed'">
                <span class="dropdown-item text-muted" style="cursor:default;">
                    <i class="ti ti-ban me-1"></i>No Actions
                </span>
                </li>
                <!-- Admin  -->
                <!-- <li v-if="auth?.role?.name !== 'Installation'">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openEdit(row)">
                    <i class="ti ti-edit me-1"></i>Edit
                    </a>
                </li> -->
                <li v-if="auth?.role?.name === 'Installation' && row.status !== 'completed' && !row.installer_name">
                  <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="assignInstaller(row)">
                    <i class="ti ti-user-plus me-1"></i>Assign to Installer
                  </a>
                </li>
                <!-- Installation person -->
                <li v-if="auth?.role?.name === 'Installation' && row.status !== 'completed'">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatusSwal(row)">
                    <i class="ti ti-refresh me-1"></i>Update Status
                    </a>
                </li>
                <li>
                <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openActivity(row)">
                    <i class="ti ti-list-details me-1"></i>Installation Activity
                </a>
                </li>
                <li>
                <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="openWhatsappLogs(row)">
                    <i class="ti ti-brand-whatsapp me-1"></i>WhatsApp Logs
                  </a>
                </li>
                <!-- Admin -->
                <!-- <li v-if="auth?.role?.name !== 'Installation' && row.status !== 'pending'">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatus(row.id, 'pending')">
                    <i class="ti ti-clock me-1 text-warning"></i>Mark Pending
                    </a>
                </li>
                <li v-if="auth?.role?.name !== 'Installation' && row.status !== 'postponed'">
                <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatusSwal(row)">
                    <i class="ti ti-clock-pause me-1 text-secondary"></i>Mark Postponed
                </a>
                </li>
                <li v-if="auth?.role?.name !== 'Installation' && row.status !== 'completed'">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" @click="updateStatus(row.id, 'completed')">
                    <i class="ti ti-circle-check me-1 text-success"></i>Mark Completed
                    </a>
                </li> -->
                <li v-if="auth?.role?.name !== 'Installation'">
                    <hr class="dropdown-divider" />
                </li>
                <li v-if="auth?.role?.name !== 'Installation'">
                    <a class="dropdown-item rounded-1 text-danger" href="javascript:void(0);" @click="deleteInstallation(row.id)">
                    <i class="ti ti-trash me-1"></i>Delete
                    </a>
                </li>
                </ul>
            </div>
            </template>

          </app-table>

        </div>
      </div>
      <!-- /Main Card -->

    </div>
    <app-footer></app-footer>
  </div>

  <installation-modal :edit-item="editItem" @saved="onSaved"></installation-modal>

  <div class="modal fade" id="installationDetailModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content" v-if="selectedInstallation">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="ti ti-tools me-2"></i>{{ selectedInstallation.installation_number }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <!-- Status -->
          <div class="col-12">
            <span :class="'badge ' + statusBadge(selectedInstallation.status).cls" style="font-size:13px;padding:6px 14px;">
              {{ statusBadge(selectedInstallation.status).label }}
            </span>
          </div>
          <!-- Sales Order -->
          <div class="col-md-6">
            <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Sales Order</label>
            <p class="mb-0 fw-medium">{{ selectedInstallation.sales_order?.so_number || selectedInstallation.sales_order_id }}</p>
            <small class="text-muted">{{ selectedInstallation.sales_order?.name }}</small>
          </div>
          <!-- Delivery Challan -->
          <div class="col-md-6">
            <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Delivery Challan</label>
            <p class="mb-0 fw-medium">{{ selectedInstallation.delivery_challan?.challan_number || selectedInstallation.delivery_challan_id }}</p>
          </div>
          <!-- Postponed At -->
        <div class="col-md-6" v-if="selectedInstallation.postponed_at">
        <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Postponed Date</label>
        <p class="mb-0 fw-medium text-warning">{{ $formatDate(selectedInstallation.postponed_at) }}</p>
        </div>
        <!-- Remark -->
        <div class="col-12" v-if="selectedInstallation.remark">
        <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Remark</label>
        <p class="mb-0">{{ selectedInstallation.remark }}</p>
        </div>
          <!-- Delivery Challan Items -->
        <div class="col-12" v-if="selectedInstallation.delivery_challan?.challan_items?.length">
        <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Challan Items</label>
        <div class="table-responsive mt-2">
        <table class="table table-sm table-bordered mb-0">
            <thead class="table-light">
            <tr>
                <th>#</th>
                <th>Item</th>
                <th>Qty</th>
                <th>Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in selectedInstallation.delivery_challan.challan_items" :key="item.id">
                <td>{{ i + 1 }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.total }}</td>
            </tr>
            </tbody>
        </table>
        </div>
        </div>

          <!-- Created At -->
          <div class="col-md-6">
            <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Created At</label>
            <p class="mb-0">{{ $formatDate(selectedInstallation.created_at) }}</p>
          </div>
          <!-- Installation Number -->
          <div class="col-md-6">
            <label class="text-muted" style="font-size:11px;text-transform:uppercase;font-weight:600;">Installation No</label>
            <p class="mb-0 fw-medium">{{ selectedInstallation.installation_number }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="installationActivityModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
    <div class="modal-content" v-if="selectedInstallation">
      <div class="modal-header border-0 pb-0">
        <div>
          <h5 class="modal-title fw-bold mb-1">Activity Log</h5>
          <span class="text-muted fs-12">{{ selectedInstallation.installation_number }}</span>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body" style="padding-top:2px !important">
        <div v-if="selectedInstallation.activities?.length" class="position-relative ms-3">
          <div class="position-absolute" style="left:6px;top:12px;bottom:12px;width:2px;background:#e9ecef;"></div>
          <div v-for="(log, index) in selectedInstallation.activities" :key="log.id"
               class="d-flex align-items-start mb-3 position-relative">
            <div class="rounded-circle flex-shrink-0 me-3 position-relative"
              :style="{
                width:'14px', height:'14px',
                background: index === 0 ? '#0d6efd' : '#adb5bd',
                border:'2px solid #fff',
                boxShadow:'0 0 0 2px ' + (index === 0 ? '#0d6efd' : '#dee2e6'),
                zIndex:1, marginTop:'3px'
              }">
            </div>
            <div class="card border shadow-none w-100 mb-0"
                 :class="index === 0 ? 'border-primary border-opacity-25' : ''">
              <div class="card-body p-2 px-3">
                <p class="mb-1 fs-13" v-html="log.description"></p>
                <small class="text-muted">
                  <i class="ti ti-clock me-1"></i>{{ $formatDate(log.created_at) }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center text-muted py-5">
          <i class="ti ti-history fs-1 d-block mb-2 opacity-50"></i>
          <p class="mb-0">No activity found.</p>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- WhatsApp Logs Modal -->
<div class="modal fade" id="whatsapp_logs_modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

      <div class="modal-header" style="background:#f0fdf4;border-bottom:1px solid #bbf7d0;padding:14px 20px;">
        <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">
          <i class="ti ti-brand-whatsapp me-2" style="color:#16a34a;"></i>
          WhatsApp Logs — {{ whatsappLogModalTitle }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body" style="padding:20px;">

        <!-- Loading -->
        <div v-if="whatsappLogsLoading" style="text-align:center;padding:30px;">
          <div class="spinner-border text-success" role="status"></div>
        </div>

        <!-- No Logs -->
        <div v-else-if="!whatsappLogs.length" style="text-align:center;padding:30px;color:#94a3b8;">
          <i class="ti ti-message-off" style="font-size:32px;display:block;margin-bottom:8px;opacity:.4;"></i>
          No WhatsApp logs found.
        </div>

        <!-- Logs List -->
        <div v-else>
          <div v-for="log in whatsappLogs" :key="log.id"
            style="border:1.5px solid #e2e8f0;border-radius:10px;padding:12px 16px;margin-bottom:10px;">

            <div style="display:flex;justify-content:space-between;align-items:flex-start;">
              <div>
                <div style="font-size:12px;font-weight:700;color:#0f172a;text-transform:capitalize;">
                  {{ log.action?.replace('_', ' ') }}
                </div>
                <div style="font-size:11px;color:#64748b;margin-top:2px;">
                  <i class="ti ti-phone" style="font-size:11px;"></i> {{ log.recipient_phone }}
                </div>
              </div>
              <span class="badge" :class="whatsappStatusBadge(log.status)" style="font-size:10px;text-transform:capitalize;">
                {{ log.status }}
              </span>
            </div>

            <div v-if="log.params_sent?.length" style="margin-top:8px;font-size:11px;color:#475569;">
              <strong>Details:</strong> {{ log.params_sent.join(', ') }}
            </div>

            <div v-if="log.error_message" style="margin-top:6px;font-size:11px;color:#f43f5e;">
              <i class="ti ti-alert-circle"></i> {{ log.error_message }}
            </div>

            <div style="margin-top:8px;font-size:10.5px;color:#94a3b8;">
              <i class="ti ti-clock-hour-3"></i> {{ formatDateTime(log.created_at) }}
            </div>

          </div>
        </div>

      </div>

      <div class="modal-footer" style="padding:12px 20px;border-top:1px solid #e2e8f0;">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
</template>